<script>
import { toRef } from "vue";
import { useField } from "vee-validate";
import Slider from '@vueform/slider'

export default {
  components: {
    Slider
  },
  inject: [ 'store'],
  emits: ["onEvaluateValueResetter"],
  props: {
    field:{},
    type: {
      type: String,
      default: "text",
    },
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    // use `toRef` to create reactive references to `name` prop which is passed to `useField`
    // this is important because vee-validte needs to know if the field name changes
    // https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
    const name = toRef(props, "name");

    // we don't provide any rules here because we are using form-level validation
    // https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
    } = useField(name, undefined, {
      initialValue: 0,
    });
    
  return {
      handleChange,
      handleBlur,
      errorMessage,
      inputValue,
      meta,
    };
  },
  computed:{
    dir(){
      return this.store.lang =='en'? 'ltr':'rtl';
    },
    sliderVal: {
      get(){
        return this.store.calcModel[this.field.id] || 0
      },
      set(value){
        this.handleChange(value)
        this.store.calcModel[this.field.id] = Number(value.toString().replaceAll(',', ''))
      }
    },
    getField: function(){
      return this.store.calcModel[this.field.id] || 0
    },
    setField: function(){
      return this.store.calcModel[this.field.id]
    }
  },
  methods:{
    minVal(field) {
      return this.store.resetterCache[field.id + "_min"]
        ? Number(this.store.resetterCache[field.id + "_min"])
        : (Number(field.min_value) || 0);
    },
    maxVal(field) {
      return this.store.resetterCache[field.id + "_max"]
        ? Number(this.store.resetterCache[field.id + "_max"])
        : (Number(field.max_value) || 0);
    },
    ResetResponseValues(value) {
      this.$emit("onEvaluateValueResetter", this.field)
      
      this.store.emptyResponse();
      if (this.store.maxValueOfAgeSlider != null) {
        const min = Number(this.store.resetterCache[this.field.id+"_min"]);
        const max = this.store.resetterCache[this.field.id+"_max"];

        let result = value;
        
        if(result > max){
          result = max;
        } else if(result < min){
          result = min;
        }

        this.store.calcModel[this.field.id] = result.toString().replaceAll(',', '');

      }
    }
  },
  mounted() {
    // console.log(this.sliderVal, this.initialValue, this.minVal(this.field));
    this.store.calcModel[this.field.id] = this.sliderVal || this.initialValue|| this.minVal(this.field);
  }
}
</script>

<template>
  <Slider 
    :max="maxVal(field)" 
    :min="minVal(field)"
    :use-keyboard="true"
    :direction="dir"
    tooltipPosition="bottom"
    showTooltip="focus"
    v-model.number="sliderVal" 
    @change="ResetResponseValues"
  />

  <div class="minMax" :id="field.id">
    <span>{{ minVal(field)?.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} {{field.place_holder}}</span>
    <span>{{ maxVal(field)?.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} {{field.place_holder}}</span>
  </div>


<input 
  type="text" 
  v-model="this.store.calcModel[this.field.id]" 
  :id="field.id" 
  :name="field.id" 
  style="display: none;" />

</template>